import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/trackers/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleTrackers),
      },
    ],
  }),
  component: TrackersPage,
});

function TrackersPage() {
  return <Navigate to="/trackers/wallets" />;
}
